import { sortRows } from 'ui/table/utils';
import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';

/**
 * useSortRows
 * Custom hook that can be used to sort rows based on a key and direction.
 * Useful for client-side pagination. There is also another hook that makes use of this function
 * to keep track of all the state needed for client-side pagination. If this is desired, take a look at:
 * - /src/ui/table/hooks/useClientPaginatedState.tsx
 */
export const useSortRows = <DataType extends Record<string, any>>(
  unsortedData: DataType[],
  sortedBy: keyof DataType,
  sortDirection: string | SORT_DIRECTIONS,
) => {
  return sortRows(unsortedData, sortedBy, sortDirection);
};
